import { useEffect, useState } from "react";
import { io } from "socket.io-client";
import { BASEURL_API_WEBSOCKET } from "../constants";

export const useWebSokect = () => {
  const [socket, setSocket] = useState<any>(null);

  useEffect(() => {
    const newSocket = io(BASEURL_API_WEBSOCKET, {
      transports: ["websocket"],     // force websocket, no polling
      secure: true,                  // required for https
      path: "/socket.io",            // required on many servers
      withCredentials: false,        // since your server uses origin: "*"
      reconnection: true,            // auto reconnect
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
    });

    setSocket(newSocket);

    newSocket.on("connect", () => {
      console.log("Connected:", newSocket.active);
    });

    newSocket.on("connect_error", (err) => {
      console.log("Socket connect error:", err.message);
    });

    return () => {
      newSocket.disconnect();
    };
  }, []);

  return {
    socket,
    setSocket,
  };
};
